import React, { useState, useEffect } from 'react';
import { fetchAvaliacao } from '../../../api/colaboracao';
import './AvaliacaoCard.css';

// Exibição read-only da avaliação (CSAT) no lado do analista (Fase 8).
function AvaliacaoCard({ satNum }) {
  const [aval, setAval] = useState(null);
  const [carregado, setCarregado] = useState(false);

  useEffect(() => {
    let ativo = true;
    if (!satNum) return undefined;
    fetchAvaliacao(satNum).then((r) => { if (ativo) { setAval(r); setCarregado(true); } });
    return () => { ativo = false; };
  }, [satNum]);

  if (!carregado || !aval || aval.nota == null) return null;

  const max = aval.tipo === 'NPS' ? 10 : 5;

  return (
    <div className="avaliacao-card">
      <div className="avaliacao-card-titulo"><i className="fas fa-star me-1" />Avaliação do solicitante</div>
      <div className="avaliacao-card-nota">
        {aval.tipo === 'NPS'
          ? <span className="avaliacao-nps">NPS {aval.nota}/10</span>
          : [1, 2, 3, 4, 5].map((n) => <i key={n} className={`fas fa-star ${n <= aval.nota ? 'cheia' : 'vazia'}`} />)}
        <span className="avaliacao-valor">{aval.nota}/{max}</span>
      </div>
      {aval.comentario && <div className="avaliacao-coment">“{aval.comentario}”</div>}
    </div>
  );
}

export default AvaliacaoCard;
